<template>
  <section id="how-it-works" v-track-visibility.once class="how-it-works">
    <div class="how-it-works__container">
      <h2 class="how-it-works__title">
        <span class="text-[#FF3D00]">Snel & eenvoudig</span
        ><br class="md:hidden" />
        verbonden in enkele<br class="md:hidden" />
        stappen!
      </h2>

      <div class="how-it-works__steps-container">
        <div class="how-it-works__vector">
          <svg
            class="how-it-works__vector--desktop"
            width="853"
            height="392"
            viewBox="0 0 853 392"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M207 5.38048H711.006C751.839 1.54715 848.006 26.1303 848.006 104.13M848.006 104.13C848.006 121.88 848.006 65.6304 848.006 104.13ZM848.006 104.13C848.006 150.88 810.506 208.88 711.006 208.88L85.5059 208.88C65.3393 209.714 5.80576 230.68 5.00576 299.88C4.20576 369.08 87.0059 390.547 119.006 385.38H668.5"
              stroke="#FF3D00"
              stroke-opacity="0.33"
              stroke-width="10"
              stroke-linecap="round"
              stroke-dasharray="20 20"
            />
          </svg>

          <svg
            class="how-it-works__vector--mobile"
            width="11"
            height="1114"
            viewBox="0 0 11 1114"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.96177 5L5.97212 1108.5"
              stroke="#FF3D00"
              stroke-opacity="0.33"
              stroke-width="10"
              stroke-linecap="round"
              stroke-dasharray="20 20"
            />
          </svg>
        </div>

        <div class="how-it-works__steps-wrapper">
          <div
            v-for="step in steps"
            :id="`how-it-works__step-${step.id}`"
            :key="step.id"
            v-track-visibility.once
            class="how-it-works__step group"
          >
            <div class="how-it-works__step-content">
              <div class="how-it-works__step-number">
                {{ step.number }}
              </div>
              <div class="how-it-works__step-icon-background">
                <span class="how-it-works__step-icon">{{
                  step.iconPlaceholder
                }}</span>
              </div>
              <h3 class="how-it-works__step-title">{{ step.title }}</h3>
              <p class="how-it-works__step-description">
                {{ step.description }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="how-it-works__cta-wrapper">
        <t-btn-link
          id="enterFormHowItWorks"
          class="how-it-works__cta-button"
          :to="enterFormPath"
        >
          Vind je makelaar
        </t-btn-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HowItWorksPD8337',

  props: {
    enterFormPath: {
      type: String,
      required: true,
    },

    steps: {
      type: Array,
      default: () => [
        {
          id: 1,
          number: 1,
          iconPlaceholder: '📝',
          title: 'Example Step 1',
          description: 'Description for step 1.',
        },
      ],
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.how-it-works {
  &__container {
    @apply container bg-white px-4 pb-20 md:pt-20;
  }

  &__title {
    @apply text-3xl md:text-4xl font-bold text-center mb-10 mt-6;
  }

  &__steps-container {
    @apply flex justify-center items-center;
  }

  &__vector {
    @apply absolute;

    &--desktop {
      @apply hidden md:block;
    }

    &--mobile {
      @apply md:hidden;
    }
  }

  &__steps-wrapper {
    @apply flex flex-col items-center max-w-[270px] mx-auto md:grid md:grid-cols-2 md:max-w-2xl md:gap-x-12 lg:gap-x-24 md:gap-y-12 lg:gap-y-20 md:relative;
  }

  &__step {
    @apply relative w-full flex flex-col items-center mb-8 md:mb-0 md:h-full;
  }

  &__step-content {
    @apply bg-white border-black/10 border-[1px] rounded-lg shadow-lg p-6 text-center w-full flex flex-col items-center mt-4 md:h-full;
  }

  &__step-number {
    @apply bg-[#FF3D00] text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm absolute top-2 left-0 -translate-x-1/2 translate-y-1/2 z-10;
  }

  &__step-icon {
    @apply text-4xl group-hover:scale-[115%] transition-transform duration-300 ease-in-out;
  }

  &__step-icon-background {
    @apply bg-secondary/30 rounded-full w-16 h-16 flex items-center justify-center mb-4 flex-shrink-0;
  }

  &__step-title {
    @apply text-lg font-bold mb-2 leading-6;
  }

  &__cta-wrapper {
    @apply flex justify-center items-center mt-10 md:mt-16;
  }

  &__cta-button {
    background: linear-gradient(167deg, #ee3b13 47.92%, #c1062b 126.29%);
    @apply border-0 font-bold px-6 py-2 rounded-lg;
  }
}
</style>
